import { Injectable, EventEmitter } from "@angular/core";
import { BaseService } from "./BaseService";
import { APIServiceConnector } from "./APIServiceConnector";
import { AppSettings } from "../Library/AppSettings";
import { MasterDataService } from "./MasterDataService";
import { CookieService } from "ngx-cookie-service";

@Injectable({
    providedIn: "root"
})
export class QrCodeService extends BaseService {
    IdentifierKey: string;
    IdentifierToken: string;
    IdentifierTokenExpiry: Date;
    Domain: string;
    redirectToHome: EventEmitter<boolean>;
    SessionURL: string;
    constructor(
        public apiService: APIServiceConnector,
        public masterService: MasterDataService,
        protected cookieService: CookieService
    ) {
        super();
        this.redirectToHome = new EventEmitter<boolean>();
    }

    public Init(): void {
        this.BaseURL = AppSettings.URL_Users;
        this.IdentifierKey = "IdentifierToken";
        this.Domain = AppSettings.Domain;
        this.SessionURL = AppSettings.URL_Session;
    }

    public setIdentifierToken(expiryDate: Date) {
        const isSecure = this.BaseURL.indexOf('https://') == 0;
        this.IdentifierTokenExpiry = expiryDate;
        this.cookieService.delete(this.IdentifierKey, "/", this.Domain);
        var cookieObj = {
            Token: this.IdentifierToken,
            Expiry: this.IdentifierTokenExpiry
        };
        this.cookieService.set(
            this.IdentifierKey,
            JSON.stringify(cookieObj),
            this.IdentifierTokenExpiry,
            "/",
            this.Domain,
            isSecure,
            'Lax'
        );
        console.info('IdentifierToken Set', cookieObj);
    }

    public getidentifierToken() {
        let token = this.cookieService.get(this.IdentifierKey);
        if (token) {
            return JSON.parse(token).Token;
        }
        return "";
    }

    public startCookieThread(): void {
        const currentTime = new Date().getTime();

        const identifierToken = this.cookieService.get(this.IdentifierKey);
        if (!identifierToken) {
            this.redirectToHome.emit(false);
            return;
        }
        const tokenExpirationTime = new Date(JSON.parse(identifierToken).Expiry);

        const timeRequiredForThread =
            tokenExpirationTime.getTime() - currentTime + 1000;

        const TIMER_LIMIT = Math.pow(2, 10) - 1;

        if (timeRequiredForThread > TIMER_LIMIT) {
            setTimeout(() => {
                this.startCookieThread();
            }, TIMER_LIMIT);
        } else {
            setTimeout(() => {
                console.info('Cookie Deleted in setTimeout');
                this.cookieService.delete(this.IdentifierKey);
                this.redirectToHome.emit(false);
            }, timeRequiredForThread);
        }
    }

    public validateIdentifierToken() {
        const token = this.cookieService.get(this.IdentifierKey);
        console.info('validateIdentifierToken - Entry');
        if (!AppSettings.WebSecurity || this.masterService.LoggedInUserData.IsPropertyAdmin) {
            return;
        }
        if (!token) {
            console.info('validateIdentifierToken - RedirectToHome - NoToken');
            this.redirectToHome.emit(false);
            return;
        }
        var req = {
            PropertyID: this.masterService.LoggedInUserData.PropertyId,
            IdentifierToken: JSON.parse(token).Token,
            WebSessionID: this.apiService.getSessionCookie(),
            UserID: this.masterService.LoggedInUserData.StaffId
        };
        this.apiService
            .postAPI(
                this.SessionURL,
                "Authentication/ValidateIdentifierToken",
                req,
                false
            )
            .then(data => {
                console.info('validateIdentifierToken - API Result', data);
                if (data && !data.HasError && data.Result) {
                    this.IdentifierTokenExpiry = data.Result.ExpiryDate;
                    this.IdentifierToken = data.Result.IdentifierToken;
                    this.setIdentifierToken(new Date(this.IdentifierTokenExpiry));
                    this.startCookieThread();
                } else {
                    console.info('validateIdentifierToken - BadResponse');
                    this.deleteIdentifierToken();
                    this.redirectToHome.emit(false);
                }
            })
            .catch(reason => console.info(reason));
    }

    public redirectToHomeScreen() {
        this.redirectToHome.emit(true);
    }

    public redirectToQrCode() {
        this.redirectToHome.emit(false);
    }

    public deleteIdentifierToken() {
        console.info('deleteIdentifierToken');
        this.cookieService.delete(this.IdentifierKey, "/", this.Domain);
    }

    public setQrCodeFeature() {
        console.info('setQrCodeFeature');
        const appFeatures = this.masterService.LoggedInUserData.AppFeatures;
        const activePropertyId = this.masterService.ActivePropertyID;
        const propertyFeatures = appFeatures[`${activePropertyId}`];

        if (!activePropertyId && !propertyFeatures) {
            console.info('setQrCodeFeature - No AppFeatures');
            return;
        }

        AppSettings.WebSecurity = propertyFeatures.AdvanceSecurity;
        AppSettings.IDTokenExpiry = propertyFeatures.WebAuthExpiry; // * 24 * 60 * 60 * 1000 ;

        console.info('setQrCodeFeature - WebSecurity -', AppSettings.WebSecurity);
    }
}
